import React from 'react';
import {
    Box,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
    Text,
    HStack,
    Icon
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

// Custom Languages Icon Component
const LanguagesIcon = (props) => (
    <Icon viewBox="0 0 24 24" {...props}>
        <path d="m5 8 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="m4 14 6-6 2-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="M2 5h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="M7 2h1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="m22 22-5-10-5 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="M14 18h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </Icon>
);

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);

        // Update document direction and language
        if (lng === 'ar') {
            document.documentElement.lang = "ar";
            document.documentElement.dir = "rtl";
        } else {
            document.documentElement.lang = "en";
            document.documentElement.dir = "ltr";
        }
    };

    const getCurrentLanguageLabel = () => {
        return i18n.language === 'ar' ? 'عربي' : 'English';
    };

    // Sits inline in the auth header row; absolute placement broke on RTL.
    return (
        <Box position="relative" zIndex="10">
            <Menu>
                <MenuButton
                    as={Button}
                    rightIcon={<ChevronDownIcon />}
                    size="sm"
                    bg="rgba(255, 255, 255, 0.15)"
                    color="white"
                    borderColor="rgba(255, 255, 255, 0.3)"
                    border="1px solid"
                    backdropFilter="blur(10px)"
                    _hover={{
                        bg: 'rgba(255, 255, 255, 0.25)',
                        color: 'white',
                        borderColor: 'rgba(255, 255, 255, 0.5)'
                    }}
                    _active={{
                        bg: 'rgba(255, 255, 255, 0.3)'
                    }}
                    fontFamily="Cairo, sans-serif"
                    fontWeight="bold"
                >
                    <HStack spacing={2}>
                        <LanguagesIcon boxSize="16px" />
                        <Text>{getCurrentLanguageLabel()}</Text>
                    </HStack>
                </MenuButton>
                <MenuList
                    bg="rgba(0, 0, 0, 0.8)"
                    backdropFilter="blur(10px)"
                    borderColor="rgba(255, 255, 255, 0.2)"
                    boxShadow="0 4px 12px rgba(0, 0, 0, 0.3)"
                >
                    <MenuItem
                        onClick={() => changeLanguage('en')}
                        bg={i18n.language === 'en' ? 'rgba(255, 255, 255, 0.15)' : 'transparent'}
                        color="white"
                        fontFamily="Cairo, sans-serif"
                        fontWeight={i18n.language === 'en' ? '600' : '400'}
                        _hover={{
                            bg: 'rgba(255, 255, 255, 0.1)'
                        }}
                    >
                        <HStack spacing={3}>
                            <Text fontSize="14px">🇺🇸</Text>
                            <Text>English</Text>
                        </HStack>
                    </MenuItem>
                    <MenuItem
                        onClick={() => changeLanguage('ar')}
                        bg={i18n.language === 'ar' ? 'rgba(255, 255, 255, 0.15)' : 'transparent'}
                        color="white"
                        fontFamily="Cairo, sans-serif"
                        fontWeight={i18n.language === 'ar' ? '600' : '400'}
                        _hover={{
                            bg: 'rgba(255, 255, 255, 0.1)'
                        }}
                    >
                        <HStack spacing={3}>
                            <Text fontSize="14px">🇸🇦</Text>
                            <Text>عربي</Text>
                        </HStack>
                    </MenuItem>
                </MenuList>
            </Menu>
        </Box>
    );
};

export default LanguageSwitcher;